<template>
    <div class="base_container">
        <div class="container no_print">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="单据日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="单据日期"></el-date-picker>
                </div>
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_out_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="起始出库日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_out_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束出库日期"></el-date-picker>
                </div>
                <div style="width:130px;float:left;position:relative;margin-right:12px;">
                    <!-- <el-select class="search_select search_inputBox search_inputBox_long selectCustomerNoDown" filterable v-model="params.search.customer_id" clearable placeholder="客户" @visible-change="getCustomerList">
                        <el-option v-for="list in customerList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                    </el-select> -->
                    <select-down-customer :salesman_id="params.search.salesman_id" :id="params.search.customer_id" ref="selectdowncustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer>
                    <!-- <select-down-customer ref="selectdowncustomer" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer> -->
                    <i class="el-input__icon el-icon-more" @click="dialogVisibleCustomer=!dialogVisibleCustomer"></i>
                </div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button class="publicBtn" @click="search">查询</el-button>
            </div>
            <div class="no_data" v-if="list.length == 0">
                <div class="no_data_icon"></div>
                <div class="no_data_text">请选择客户名称查询</div>
            </div>
            <div class="order_data no_print" v-else>
                <p class="title_row">客户对账单</p>
                <div class="company_name">
                    <span>{{ customer.company_name }}</span>
                    <div class="">
                        <el-button class="publicBtn" @click="print">打印</el-button>
                        <div class="execlInsert" @click="exportExcel">
                            <span class="excel_btn"><i class="excel-icon"></i>excel导出</span>
                        </div>
                    </div>
                </div>
                <p class="base_row">
                    <span>客户：{{ customer_name }}</span>
                    <span>联系人：{{ customer.linkman }}</span>
                    <span>电话：{{ customer.phone }}</span>
                </p>
                <p class="other_row">
                    <span>地址：{{ customer.address }}</span>
                    <span>日期：{{ customer.start_time | dateFormat }}至{{ customer.end_time | dateFormat }}</span>
                </p>
                <div class="tableBox">
                    <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list"></tabletem>
                </div>
                <div class="totalCal">
                    <div class="totalName">合计：</div>
                    <div class="totalNumber">销售金额：{{ statistics.sales_amount }}</div>
                    <div class="totalNumber">应收金额：{{ statistics.receivables_amount }}</div>
                    <div class="totalNumber">应收款余额：{{ statistics.balance_amount }}</div>
                </div>
            </div>
        </div>
        <!--选择客户START-->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleCustomer" class="eldialog eldialogStock" width="825px" :modal="false" title="选择客户" custom-class="full_dialog">
            <select-customer :saleman="params.search.salesman_id" @cancel="dialogVisibleCustomer=!dialogVisibleCustomer" @selectAndOut="selectAndOutCustomer"></select-customer>
        </el-dialog>
        <!--选择客户END-->
        <div class="print">
            <div class="printTable">
                <p class="title_row">客户对账单</p>
                <div class="company_name">
                    <span>{{ customer.company_name }}</span>
                </div>
                <p class="base_row">
                    <span>客户：{{ customer_name }}</span>
                    <span>联系人：{{ customer.linkman }}</span>
                    <span>电话：{{ customer.phone }}</span>
                </p>
                <p class="other_row">
                    <span>地址：{{ customer.address }}</span>
                    <span>日期：{{ customer.start_time | dateFormat }}至{{ customer.end_time | dateFormat }}</span>
                </p>
                <div class="tableBox printTableBox">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>单据日期</th>
                                <th>单据编号</th>
                                <th>单据类型</th>
                                <th>销售金额</th>
                                <th>优惠金额</th>
                                <th>应收金额</th>
                                <th>实际收款金额</th>
                                <th>应收款余额</th>
                                <th>备注</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in list" :key="index">
                                <td>{{ item.sales_time }}</td>
                                <td>{{ item.order_sn }}</td>
                                <td>{{ item.status_text }}</td>
                                <td>{{ item.sales_amount }}</td>
                                <td>{{ item.reduce_amount }}</td>
                                <td>{{ item.receivables }}</td>
                                <td>{{ item.income }}</td>
                                <td>{{ item.receivables_balance }}</td>
                                <td>{{ item.remark }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="totalCal">
                    <div class="totalName">合计：</div>
                    <div class="totalNumber">销售金额：{{ statistics.sales_amount }}</div>
                    <div class="totalNumber">应收金额：{{ statistics.receivables_amount }}</div>
                    <div class="totalNumber">应收款余额：{{ statistics.balance_amount }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .el-icon-more {position: absolute;right: 0;top:0;cursor: pointer;}
    .base_container{ display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; }
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2; flex: 1;
    }
    .no_data{
        width:1092px; height:466px; background:rgba(255,255,255,1); box-shadow:0px 0px 6px rgba(0,0,0,0.16); border-radius:6px; display: flex; align-items: center; justify-content:center; margin-top:20px; margin-left:7px;
        .no_data_icon{ display:inline-block; width: 219px; height: 192px; background:url("/icon/no_order.png") no-repeat center; background-size: contain; }
        .no_data_text{ font-size:24px; margin-left:80px; color: #9D9D9D; }
    }
    .order_data{
        display:flex; flex-direction:column; flex: 1; width:1230px; padding: 27px 15px 15px; background:rgba(255,255,255,1); box-shadow:0px 0px 6px rgba(0,0,0,0.16); border-radius:6px; margin-top:20px; margin-left:7px;
    }
    p{ margin: 0; padding: 0; }
    .title_row{ text-align : center; font-size:18px; color: #333333; font-weight:bold; line-height:25px; margin-bottom: 3px; }
    .company_name{
        text-align:center; position: relative; line-height: 30px; margin-bottom:30px;
        & > div{ position: absolute; right: 0; display: flex; align-items:center; top: 0;  }
        .execlInsert{ float: unset; position: relative; top: unset; bottom: unset; right: unset; margin-left: 20px; }
    }
    .base_row{
        color: #333333; font-size:12px; margin-bottom: 12px;
        & > span{ margin-right: 35px; }
    }
    .other_row{ margin-bottom: 20px; display:flex; align-items: center; justify-content: space-between; color: #333333; font-size:12px; }
    .totalCal{ margin-top: 10px; }
    .totalName, .totalNumber{ color: #333333 }
    .print{
        .table{
            width:100%;border-collapse:collapse;
            td, th{ border:1px solid #ccc;font-size: 14px;padding:5px;}
        }
    }
</style>
<script>
    // import pagination from '../../../components/pagination.vue'
    import tabletem from '../../../components/table.vue'
    import selectDownCustomer from '../../../components/selectDownCustomer.vue'
    export default {
        components:{
            tabletem,
            // pagination,
            selectDownCustomer
        },
        data(){
            return{
                tableLoading:false,
                start_time : "",
                end_time : new Date(),
                start_out_time:"",
                end_out_time:"",
                params:{
                    page : 1,
                    per_page : 10,
                    search : {
                        start_time : 0,
                        end_time : 0,
                        customer_id : ""
                    }
                },
                dialogVisibleCustomer:false,
                last_page : 1,
                current_page : 1,
                total:0,
                statistics : {
                    sales_amount : "",
                    reduce_amount : "",
                    already_amount : "",
                    outstanding_amount : "",
                },

                customerList: [],
                customer_name : "",
                customer : {
                    company_name : localStorage.dw_erp_company_name,
                    linkman : "",
                    phone : "",
                    address : "",
                    start_time: "",
                    end_time: "",
                },
                list:[],
                tableCol:[
                    {colName:"单据日期",colKey:"sales_time",colWidth:128,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"出库日期",colKey:"out_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"单据编号",colKey:"order_sn",colWidth:170,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"单据类型",colKey:"status_text",colWidth:108,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售金额",colKey:"sales_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"其他费用金额",colKey:"other_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"优惠金额",colKey:"reduce_amount",colWidth:111,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"应收金额",colKey:"receivables",colWidth:93,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"实际收款金额",colKey:"income",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"应收款余额",colKey:"receivables_balance",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:142,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
            }
        },
        created() {
            this.start_time = this.$getCurrentMonthStartValueOf();
            this.getCustomerList(true)
        },
        methods:{
            selectAndOutCustomer(row){
                this.params.search.customer_id=row[0].id;
                this.dialogVisibleCustomer = !this.dialogVisibleCustomer;
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            getList(){
                this.$axios.post("/erp/report.customer.order",this.params).then((response) => {
                    if(response.data.code == 0){
                        let list = response.data.data.list
                        list.forEach((item,index) => {
                            // list[index].sales_amount = this.keepPrice(item.sales_amount);
                            // list[index].other_amount = this.keepPrice(item.other_amount);
                            // list[index].reduce_amount = this.keepPrice(item.reduce_amount);
                            // list[index].receivables = this.keepPrice(item.receivables);
                            // list[index].income = this.keepPrice(item.income);
                            // list[index].receivables_balance = this.keepPrice(item.receivables_balance);
                            if(item.sales_time!=0){
                                item.sales_time = window.moment( Number(item.sales_time) * 1000 ).format("YYYY-MM-DD")
                            }else{
                                item.sales_time = 0;
                            }
                            if(item.out_time!=0){
                                item.out_time = window.moment( Number(item.out_time) * 1000 ).format("YYYY-MM-DD")
                            }else{
                                item.out_time = 0;
                            }
                        })
                        list.unshift({sales_time:"",order_sn:"客户余额",sales_amount:"",other_amount:"",reduce_amount:"",receivables:"",income:"",receivables_balance:response.data.data.first_balance,status_text:"",remark:""})
                        this.list = list;
                        this.statistics = response.data.data.statistics;
                        this.customer = response.data.data.customer;
                        this.customer.start_time = parseInt(this.start_time / 1000);
                        this.customer.end_time = parseInt(this.end_time / 1000);
                        this.customerList.forEach(item => {
                            if(item.id === this.params.search.customer_id){
                                this.customer_name = item.name;
                            }
                        })
                        this.customer.company_name=localStorage.dw_erp_company_name;
                    } else {
                        this.list = [];
                    }
                }).catch((error) => {
                    window.console.log(error);
                })
            },
            exportExcel() {
                this.$exportExecl("/erp/export.customer.order.list", "客户对账单", this.params);
            },
            search(){
                this.params.search.start_time = parseInt(this.start_time / 1000) == 0 ? "" : parseInt(this.start_time / 1000);
                this.params.search.end_time = parseInt(this.end_time / 1000) == 0 ? "" : parseInt(this.end_time / 1000);
                this.params.search.start_out_time = parseInt(this.start_out_time / 1000) == 0 ? "" : parseInt(this.start_out_time / 1000);
                this.params.search.end_out_time = parseInt(this.end_out_time / 1000) == 0 ? "" : parseInt(this.end_out_time / 1000);
                if(this.params.page == 1){
                    this.getList();
                } else {
                    this.params.page = 1
                }
            },
            reset(){
                this.start_time = this.$getCurrentMonthStartValueOf();
                this.end_time = new Date();
                this.start_out_time = "";
                this.end_out_time = "";
                this.params.search = {
                    start_time : 0,
                    end_time : 0,
                    start_out_time:"",
                    end_out_time:"",
                    order_sn : "",
                    customer_id : ""
                }
            },

            // 获取客户
            getCustomerList(visible){
                if(visible){
                    this.$getCustomerList(this.params.search.salesman_id).then(res=>{
                        this.customerList = res.data.data;
                    })
                }
            },

            print(){
                setTimeout(() => {
                    window.print()
                }, 0);
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.search();
            }
        }
    }
</script>
